export function RocketIcon({
  className,
  pathClassName,
}: {
  className?: string;
  pathClassName?: string;
}) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.99999 12.5L7.49999 10M9.99999 12.5C11.164 12.0573 12.2807 11.499 13.3333 10.8334M9.99999 12.5V16.6667C9.99999 16.6667 12.525 16.2084 13.3333 15C14.2333 13.65 13.3333 10.8334 13.3333 10.8334M7.49999 10C7.94345 8.84957 8.50183 7.74676 9.16666 6.70838C10.1376 5.15587 11.4897 3.87758 13.0942 2.99512C14.6986 2.11266 16.5022 1.65535 18.3333 1.66671C18.3333 3.93338 17.6833 7.91671 13.3333 10.8334M7.49999 10H3.33333C3.33333 10 3.79166 7.47504 4.99999 6.66671C6.34999 5.76671 9.16666 6.66671 9.16666 6.66671M3.74999 13.75C2.49999 14.8 2.08333 17.9167 2.08333 17.9167C2.08333 17.9167 5.19999 17.5 6.24999 16.25C6.84166 15.55 6.83333 14.475 6.17499 13.825C5.85108 13.5159 5.42441 13.3372 4.97685 13.3234C4.52929 13.3096 4.09239 13.4615 3.74999 13.75Z"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </svg>
  );
}
